import { render, staticRenderFns } from "./dialogEditValue.vue?vue&type=template&id=0b2c12e0&scoped=true"
import script from "./dialogEditValue.vue?vue&type=script&lang=js"
export * from "./dialogEditValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2c12e0",
  null
  
)

export default component.exports